///<reference path="../../../../../typings/index.d.ts"/>

module Meevo.Components.Controls.HideInput {

    import CultureSettings = Meevo.Components.Common.CultureSettings;
    import Phone = Meevo.Model.Phone;

    export const hideInputFilter = () => {
        const filter = (data: string | Phone, converterName: AvailableConverters = 'email') => {

            if (!data) {
                return '';
            }

            switch (converterName) {
                case 'email':
                    return new EmailStringConverter().hide(data as string);
                case 'phone':
                    if (!(data as Phone).countryCode) return '';

                    return new PhoneConverter({ cultureModel: CultureSettings.getByCountryCode((data as Phone).countryCode) }).hide((data as Phone).number);
                default:
                    return '';
            }

        };


        return filter;
    };


    angular.module('meevo.components.controls.HideInput')
        .filter('hideInput', hideInputFilter);
}
